import { type InputBaseProps } from '@mui/material'
import InputBase from '@mui/material/InputBase'
import { memo } from 'react'

import CustomNumericFormat from '@/components/base/CustomNumericFormat'
import { useEventCallback } from '@/utils/use-event-callback'

export type BaseAmountInputProps = InputBaseProps & {
  value?: number
  maxLimit?: number
  decimals?: number
  debounceMilliseconds?: number
}

const BaseAmountInput = ({ inputProps, maxLimit, decimals = 9, debounceMilliseconds, ...props }: BaseAmountInputProps) => {
  const onInputFocus = useEventCallback((event: React.FocusEvent<HTMLInputElement>) => {
    if (Number(event.target.value) === 0) {
      event.target.select()
    }
  })

  return (
    <InputBase
      inputComponent={CustomNumericFormat as any}
      placeholder="0"
      inputProps={{
        'aria-label': '0',
        className: 'p-0 text-xl iw:text-[#000E0F] font-semibold',
        min: 0,
        ...(inputProps || {}),
        decimalScale: decimals,
        allowNegative: false,
        thousandSeparator: ',',
        inputMode: 'decimal',
        maxLimit,
        debounceMilliseconds,
      }}
      onFocus={onInputFocus}
      {...props}
    />
  )
}

export default memo(BaseAmountInput)
